import {
  Tooltip,
  Link,
  Button,
  Box,
  Stack,
  IconButton,
  Typography,
} from "fashion/fabrics";
import {
  CardMemoirIcon,
  EmailIcon,
  LinkedInIcon,
  InstagramIcon,
  YouTubeIcon,
  SendIcon,
  XIcon,
} from "fashion/icons";
import BlogCardCarousel from "nodes/blog/BlogCardCarousel";

const LINK_MAIL_TO_EMAIL =
  "mailto:concept@memoir.cards?subject=Card%20Memoir%20Concept%20Contact";
const LINK_CARD_MEMOIR = "https://memoir.cards/_/@Fw3cnx5X9EPAkr9DigVv2M9ctv52";
const LINK_INSTAGRAM = "https://www.instagram.com/cardmemoir/";
const LINK_YOUTUBE = "https://www.youtube.com/@CardMemoir";
const LINK_LINKEDIN = "http://linkedin.com/company/mizony";
const LINK_TWITTER = "https://x.com/Libramium";

const CodexContact = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      Social{" "}
      <Box color="secondary.main" component="span" display="inline">
        Promotion
      </Box>{" "}
      growth
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      Share your promotional idea with us and receive a{" "}
      <Box color="secondary.main" component="span" display="inline">
        free handmade card.
      </Box>
    </Typography>
    <Box margin="auto">
      <Button
        component={Link}
        href={LINK_MAIL_TO_EMAIL}
        size="large"
        variant="outlined"
        color="secondary"
        startIcon={<SendIcon />}
        endIcon={<EmailIcon />}
      >
        Contact us
      </Button>
      <Typography
        mt={0.5}
        color="text.disabled"
        textAlign="center"
        variant="body2"
      >
        We will reply within 1-2 days
      </Typography>
    </Box>
    <Box display="flex" justifyContent="center">
      <Tooltip title="LinkedIn @CardMemoir">
        <IconButton component={Link} href={LINK_LINKEDIN} size="large">
          <LinkedInIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Twitter/X @Libramium">
        <IconButton component={Link} href={LINK_TWITTER} size="large">
          <XIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <Tooltip title="CardMemoir @Fw3cnx…">
        <IconButton component={Link} href={LINK_CARD_MEMOIR} size="large">
          <CardMemoirIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Instagram @CardMemoir">
        <IconButton component={Link} href={LINK_INSTAGRAM} size="large">
          <InstagramIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <Tooltip title="YouTube @CardMemoir">
        <IconButton component={Link} href={LINK_YOUTUBE} size="large">
          <YouTubeIcon fontSize="large" />
        </IconButton>
      </Tooltip>
    </Box>
    <Typography color="text.disabled" textAlign="center">
      #CardMemoir
    </Typography>
    <BlogCardCarousel />
  </Stack>
);

export default CodexContact;
